/**
 * Advanced Filter Component Internationalization - English
 */
export default {
  // FCL Container Rate Filter Fields
  fcl: {
    labels: {
      routeCode: 'Rate Code',
      rateType: 'Rate Type',
      departurePort: 'Departure Port',
      dischargePort: 'Discharge Port',
      directTransit: 'Direct/Transit',
      transitPort: 'Transit Port',
      transitType: 'Transit Type',
      shipCompany: 'Shipping Company',
      contractNo: 'Contract No',
      spaceStatus: 'Space Status',
      priceStatus: 'Price Trend',
      cargoType: 'Cargo Type',
      vesselSchedule: 'Vessel Schedule',
      voyage: 'Voyage',
      freeStorageDays: 'Free Storage Days',
      nac: 'NAC',
      validPeriod: 'Valid Period',
      etd: 'ETD',
      eta: 'ETA',
      vesselName: 'Vessel Name',
      voyageNo: 'Voyage No',
      cutoffDate: 'Cutoff Date',
      destinationRegion: 'Destination Region',
      entryPerson: 'Created By',
      createDate: 'Create Date',
      rateModifier: 'Rate Modifier',
      modifyDate: 'Modify Date',
      rateStatus: 'Rate Status',
      routeName: 'Route Name',
      routeCodeSelect: 'Route Code',
      terminal: 'Terminal',
      branch: 'Branch'
    },
    placeholders: {
      routeCode: 'Enter rate code',
      rateType: 'Select rate type',
      departurePort: 'Select departure port',
      dischargePort: 'Select discharge port',
      directTransit: 'Select direct/transit',
      transitPort: 'Select transit port',
      transitType: 'Select transit type',
      shipCompany: 'Select shipping company',
      contractNo: 'Select contract no',
      spaceStatus: 'Select space status',
      priceStatus: 'Select price trend',
      cargoType: 'Select cargo type',
      vesselSchedule: 'Select vessel schedule',
      voyage: 'Enter voyage',
      freeStorageDays: 'Enter free storage days',
      nac: 'Select NAC',
      validPeriod: 'Select valid period range',
      etd: 'Select ETD range',
      eta: 'Select ETA range',
      vesselName: 'Enter vessel name',
      voyageNo: 'Enter voyage no',
      cutoffDate: 'Select cutoff date range',
      destinationRegion: 'Enter destination region',
      entryPerson: 'Enter created by',
      createDate: 'Select create date range',
      rateModifier: 'Enter rate modifier',
      modifyDate: 'Select modify date range',
      rateStatus: 'Select rate status',
      routeName: 'Select route name',
      routeCodeSelect: 'Select route code',
      terminal: 'Select terminal',
      branch: 'Select branch'
    }
  },

  // LCL Container Rate Filter Fields
  lcl: {
    labels: {
      rateCode: 'Rate Code',
      rateType: 'Rate Type',
      departurePort: 'Departure Port',
      dischargePort: 'Discharge Port',
      transitType: 'Direct/Transit',
      shipCompany: 'Shipping Company',
      weightRange: 'Weight Range',
      volumeRange: 'Volume Range',
      validPeriod: 'Validity',
      etd: 'ETD',
      eta: 'ETA',
      cutoffDate: 'Cutoff Date',
      createDate: 'Create Date',
      modifyDate: 'Modify Date'
    },
    placeholders: {
      rateCode: 'Enter rate code',
      rateType: 'Select rate type',
      departurePort: 'Select departure port',
      dischargePort: 'Select discharge port',
      transitType: 'Select direct/transit',
      shipCompany: 'Select shipping company',
      weightRange: 'Enter weight range',
      volumeRange: 'Enter volume range',
      validPeriod: 'Select validity range',
      etd: 'Select ETD range',
      eta: 'Select ETA range',
      cutoffDate: 'Select cutoff date range',
      createDate: 'Select create date range',
      modifyDate: 'Select modify date range'
    }
  },

  // Air Rate Filter Fields
  air: {
    labels: {
      rateCode: 'Rate Code',
      rateType: 'Rate Type',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      airline: 'Airline',
      weightRange: 'Weight Range',
      validPeriod: 'Validity',
      flightDate: 'Flight Date',
      createDate: 'Create Date',
      modifyDate: 'Modify Date'
    },
    placeholders: {
      rateCode: 'Enter rate code',
      rateType: 'Select rate type',
      departureAirport: 'Select departure airport',
      arrivalAirport: 'Select arrival airport',
      airline: 'Select airline',
      weightRange: 'Enter weight range',
      validPeriod: 'Select validity range',
      flightDate: 'Select flight date range',
      createDate: 'Select create date range',
      modifyDate: 'Select modify date range'
    }
  },

  // Pre-port Rate Filter Fields
  precarriage: {
    labels: {
      rateCode: 'Rate Code',
      rateType: 'Rate Type',
      origin: 'Origin',
      destination: 'Departure Port',
      terminal: 'Terminal',
      vendor: 'Supplier',
      validPeriod: 'Validity',
      status: 'Status',
      entryPerson: 'Created By',
      createDate: 'Create Date',
      rateModifier: 'Modifier',
      modifyDate: 'Modify Date'
    },
    placeholders: {
      rateCode: 'Enter rate code',
      rateType: 'Select rate type',
      origin: 'Enter origin',
      destination: 'Select departure port',
      terminal: 'Select terminal',
      vendor: 'Enter supplier',
      validPeriod: 'Select validity range',
      status: 'Select status',
      entryPerson: 'Enter created by',
      createDate: 'Select create date range',
      rateModifier: 'Enter modifier',
      modifyDate: 'Select modify date range'
    }
  },

  // Last-mile Rate Filter Fields
  oncarriage: {
    labels: {
      rateCode: 'Rate Code',
      origin: 'Destination Port',
      addressType: 'Delivery Address Type',
      zipCode: 'Postal Code',
      address: 'Address',
      agentName: 'Agent Name',
      validPeriod: 'Validity',
      status: 'Status'
    },
    placeholders: {
      rateCode: 'Enter rate code',
      origin: 'Enter destination port',
      addressType: 'Select delivery address type',
      zipCode: 'Enter postal code',
      address: 'Enter address',
      agentName: 'Enter agent name',
      validPeriod: 'Select validity range',
      status: 'Select status'
    }
  },

  // Inquiry Filter Fields
  inquiry: {
    labels: {
      inquiryNo: 'Inquiry No',
      source: 'Inquiry Source',
      inquirerId: 'Inquirer',
      status: 'Inquiry Status',
      carrierId: 'Carrier',
      trunkLineEnable: 'Trunk Line Quote Status',
      prePortEnable: 'Pre-port Quote Status',
      lastMileEnable: 'Last Mile Quote Status',
      cargoReadyTimeType: 'Cargo Ready Time Type',
      cargoReadyTimeRange: 'Cargo Ready Time Range',
      cargoReadyTimeDate: 'Cargo Ready Time',
      palletNature: 'Pallet Nature',
      directTransit: 'Direct/Transit',
      routeId: 'Route',
      loadingPortId: 'Loading Port',
      dischargingPortId: 'Discharging Port',
      destinationPortId: 'Destination Port',
      cargoType: 'Cargo Type',
      serviceTerm: 'Service Term',
      customServiceTerm: 'Custom Service Term',
      clientType: 'Client Type',
      clientTitle: 'Client Name',
      seaEq: 'Container Type & Quantity',
      remarks: 'Remarks',
      dateCreated: 'Create Time',
      dateModified: 'Modify Time',
      createdBy: 'Created By',
      modifiedBy: 'Modified By'
    },
    placeholders: {
      inquiryNo: 'Enter inquiry no',
      source: 'Select inquiry source',
      inquirerId: 'Select inquirer',
      status: 'Select inquiry status',
      carrierId: 'Select carrier',
      trunkLineEnable: 'Select trunk line quote status',
      prePortEnable: 'Select pre-port quote status',
      lastMileEnable: 'Select last mile quote status',
      cargoReadyTimeType: 'Select cargo ready time type',
      cargoReadyTimeRange: 'Select cargo ready time range',
      cargoReadyTimeDate: 'Select cargo ready time range',
      palletNature: 'Select pallet nature',
      directTransit: 'Select direct/transit',
      routeId: 'Select route',
      loadingPortId: 'Select loading port',
      dischargingPortId: 'Select discharging port',
      destinationPortId: 'Select destination port',
      cargoType: 'Select cargo type',
      serviceTerm: 'Select service term',
      customServiceTerm: 'Enter custom service term',
      clientType: 'Select client type',
      clientTitle: 'Enter client name',
      seaEq: 'Enter container type & quantity',
      remarks: 'Enter remarks',
      dateCreated: 'Select create time range',
      dateModified: 'Select modify time range',
      createdBy: 'Select created by',
      modifiedBy: 'Select modified by'
    }
  },

  // Quotation Filter Fields
  quotation: {
    labels: {
      quotationNo: 'Quotation No',
      inquiryNo: 'Inquiry No',
      quoterId: 'Quoter',
      source: 'Quotation Source',
      status: 'Quotation Status',
      carrierId: 'Carrier',
      trunkLineEnable: 'Trunk Line Quote Status',
      prePortEnable: 'Pre-port Quote Status',
      lastMileEnable: 'Last Mile Quote Status',
      cargoReadyTimeType: 'Cargo Ready Time Type',
      cargoReadyTimeRange: 'Cargo Ready Time Range',
      cargoReadyTimeDate: 'Cargo Ready Time',
      palletNature: 'Pallet Nature',
      directTransit: 'Direct/Transit',
      routeId: 'Route',
      loadingPortId: 'Loading Port',
      dischargingPortId: 'Discharging Port',
      destinationPortId: 'Destination Port',
      clientType: 'Client Type',
      clientTitle: 'Client Name',
      seaEq: 'Container Type & Quantity',
      remarks: 'Remarks',
      dateCreated: 'Create Time',
      dateModified: 'Modify Time',
      createdBy: 'Created By',
      modifiedBy: 'Modified By'
    },
    placeholders: {
      quotationNo: 'Enter quotation no',
      inquiryNo: 'Enter inquiry no',
      quoterId: 'Select quoter',
      source: 'Select quotation source',
      status: 'Select quotation status',
      carrierId: 'Select carrier',
      trunkLineEnable: 'Select trunk line quote status',
      prePortEnable: 'Select pre-port quote status',
      lastMileEnable: 'Select last mile quote status',
      cargoReadyTimeType: 'Select cargo ready time type',
      cargoReadyTimeRange: 'Select cargo ready time range',
      cargoReadyTimeDate: 'Select cargo ready time range',
      palletNature: 'Select pallet nature',
      directTransit: 'Select direct/transit',
      routeId: 'Select route',
      loadingPortId: 'Select loading port',
      dischargingPortId: 'Select discharging port',
      destinationPortId: 'Select destination port',
      clientType: 'Select client type',
      clientTitle: 'Enter client name',
      seaEq: 'Enter container type & quantity',
      remarks: 'Enter remarks',
      dateCreated: 'Select create time range',
      dateModified: 'Select modify time range',
      createdBy: 'Select created by',
      modifiedBy: 'Select modified by'
    }
  },

  // Enum Values Translation
  enums: {
    // Rate Type
    rateType: {
      contract: 'Contract',
      spot: 'SPOT',
      peer: 'Peer Price',
      ratio: 'Ratio Price'
    },
    // Route Type
    routeType: {
      direct: 'Direct',
      transit: 'Transit'
    },
    // Yes/No
    yesNo: {
      yes: 'Yes',
      no: 'No'
    },

    // Space Status
    spaceStatus: {
      smooth: 'Smooth',
      normal: 'Normal',
      singleApply: 'Single Apply',
      overbooked: 'Overbooked',
      rejected: 'Rejected',
      limited: 'Limited',
      suspended: 'Suspended',
      inquiry: 'Inquiry'
    },
    // Space Nature
    spaceNature: {
      selfOperated: 'Self-Operated',
      shared: 'Shared'
    },
    // Special Price Status
    specialPriceStatus: {
      notAllowed: 'Not Allowed',
      allowed: 'Allowed',
      special: 'Special Price'
    },
    // Lane Type
    laneType: {
      economy: 'Economy',
      express: 'Express'
    },
    // Container Ownership
    containerOwnership: {
      coc: 'COC-Carrier-Owned',
      soc: 'SOC-Shipper-Owned'
    },
    // Price Trend
    priceTrend: {
      up: 'Up',
      down: 'Down',
      stable: 'Stable'
    },
    // Cargo Type
    cargoType: {
      general: 'General Cargo',
      dangerous: 'Dangerous Goods',
      frozen: 'Frozen Goods',
      special: 'Special Cargo',
      steelCoil: 'Steel Coil',
      liquid: 'Liquid',
      chemical: 'Chemical',
      textile: 'Textile',
      liveAnimals: 'Live Animals'
    },
    // Week Day
    weekDay: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    },

    // Rate Status
    rateStatus: {
      draft: 'Draft',
      published: 'Published',
      invalid: 'Invalid',
      offline: 'Offline',
      disabled: 'Disabled',
      pendingImport: 'Pending Import'
    },

    // Inquiry Type
    inquiryType: {
      fcl: 'FCL Inquiry',
      lcl: 'LCL Inquiry',
      air: 'Air Inquiry',
      prePort: 'Pre-port Inquiry',
      lastMile: 'Last Mile Inquiry'
    },

    // Inquiry Status
    inquiryStatus: {
      draft: 'Draft',
      submitted: 'Submitted',
      sent: 'Sent',
      quoted: 'Quoted',
      confirmed: 'Confirmed',
      consulting: 'Consulting',
      inStock: 'In Stock',
      closed: 'Closed'
    },

    // Quotation Type
    quotationType: {
      fcl: 'FCL Quotation',
      lcl: 'LCL Quotation',
      air: 'Air Quotation',
      prePort: 'Pre-port Quotation',
      lastMile: 'Last Mile Quotation'
    },

    // Quotation Status
    quotationStatus: {
      draft: 'Draft',
      submitted: 'Submitted'
    },

    // Quote Status
    quoteStatus: {
      pending: 'Pending',
      quoted: 'Quoted',
      notEnabled: 'Not Enabled',
      rejected: 'Rejected'
    },

    // Pallet Nature
    palletNature: {
      inquiry: 'Inquiry',
      booking: 'Booking'
    },

    // Shokz Inquiry Nature
    shokzInquiryNature: {
      priceCheck: 'Price Check',
      formalInquiry: 'Formal Inquiry'
    },

    // Inquiry Source
    inquirySource: {
      internal: 'Internal',
      client: 'Client',
      agentWecom: 'WeCom Agent',
      cargowareXAgent: 'CargowareX Agent',
      emailAgent: 'Email Agent',
      familyAgent: 'Family Agent'
    },

    // Quotation Source
    quotationSource: {
      internal: 'Internal Inquiry',
      external: 'External Inquiry',
      direct: 'Direct Create',
      thirdPartySystemPush: 'Third Party System Push'
    },

    // Client Type
    clientType: {
      none: 'Not Specified',
      formal: 'Formal Client',
      temporary: 'Temporary Client'
    },

    // Delivery Address Type
    deliveryAddressType: {
      thirdParty: 'Third Party Address',
      amazon: 'Amazon Warehouse',
      ecang: 'ECang'
    },

    // Direct/Transit
    directTransit: {
      direct: 'Direct',
      transit: 'Transit',
      none: 'Not Specified'
    },

    // Cargo Ready Time Type
    cargoReadyTimeType: {
      range: 'Range',
      date: 'Date'
    },
    // Container Requirement
    containerRequirement: {
      generalDry: 'General Dry Container',
      reefer: 'Reefer Container',
      openTop: 'Open Top Container'
    },

    // Cargo Ready Time Range
    cargoReadyTimeRange: {
      threeDays: 'Within 3 Days',
      oneWeek: 'Within 1 Week',
      twoWeeks: 'Within 2 Weeks',
      oneMonth: 'Within 1 Month',
      moreThanMonth: 'More Than 1 Month',
      unknown: 'Unknown'
    },
    surchargeFeeStatus: {
      disabled: 'Disabled',
      enabled: 'Enabled',
      expired: 'Expired'
    },
    surchargeType: {
      oceanFcl: 'Ocean FCL',
      prePort: 'Pre-Port',
      lastMile: 'Last Mile',
      oceanLcl: 'Ocean LCL',
      air: 'Air Freight'
    },
    surchargeFeeType: {
      oceanFreight: 'Ocean Surcharge',
      pol: 'POL Charges',
      pod: 'POD Charges'
    },
    paymentType: {
      prepaid: 'Prepaid',
      collect: 'Collect',
      prepaidOrCollect: 'Prepaid/Collect'
    },
    // Service Term
    serviceTerm: {
      fob: 'FOB',
      cif: 'CIF',
      cfr: 'CFR',
      ddp: 'DDP',
      custom: 'Custom'
    },

    // Price Type
    priceType: {
      fcl: 'FCL',
      prePortLastMile: 'Pre-port & Last Mile'
    },

    // Price PrePort/LastMile Type
    pricePrePortLastMileType: {
      prePort: 'Pre-port Price',
      lastMile: 'Last Mile Price'
    },

    // Charging Item Type
    chargingItemType: {
      container: 'Container-based',
      nonContainer: 'Non-container-based'
    },

    // Belonging Alliance
    belongingAlliance: {
      twoMAlliance: '2M Alliance',
      oceanAlliance: 'Ocean Alliance',
      theAlliance: 'THE Alliance',
      independentOperation: 'Independent Operation'
    },
    status: {
      enable: 'Enable',
      disable: 'Disable'
    },
    warehouseType: {
      amazon: 'Amazon',
      ecang: 'ECang',
      other: 'Other',
      factory: 'Factory Warehouse',
      fba: 'FBA Warehouse',
      thirdParty: '3PL Warehouse',
      selfOwned: 'Self-owned Warehouse',
      overseas: 'Overseas Warehouse',
      transit: 'Transit Warehouse'
    },
    priceMethod: {
      direct: 'Direct',
      branch: 'Branch',
      seaRail: 'Sea Rail'
    },
    preportTransportMode: {
      truck: 'Truck',
      barge: 'Barge',
      rail: 'Rail'
    },
    templateUsage: {
      print: 'Print',
      email: 'Email'
    },
    businessType: {
      sea: 'Ocean Shipping',
      air: 'Air Freight',
      rail: 'Rail Transport',
      land: 'Land Transport'
    },
    freightType: {
      fcl: 'FCL',
      prePort: 'Pre-port',
      lastMile: 'Last Mile',
      lcl: 'LCL',
      air: 'Air Freight',
      rail: 'Rail Transport',
      land: 'Land Transport'
    },
    dedicatedType: {
      sales: 'Sales',
      service: 'Customer Service',
      document: 'Documentation',
      business: 'Business',
      operation: 'Operation',
      shipping: 'Shipping',
      accounting: 'Accounting'
    },
    enterpriseType: {
      customer: 'Customer Enterprise',
      tenant: 'Tenant Enterprise'
    },
    syncPlatform: {
      cargoware: 'CargoWare',
      etower: 'eTower'
    },
    syncMode: {
      auto: 'Auto',
      manual: 'Manual'
    },
    orderSyncStatus: {
      notSynced: 'Not Synced',
      syncing: 'Syncing',
      synced: 'Synced',
      syncFailed: 'Sync Failed',
      preReviewRejected: 'Pre-Review Rejected'
    },
    // Hazardous Goods Class (aligned with backend HazardClassEnum)
    hazardClass: {
      class1: '1.1 Explosives with a mass explosion hazard',
      class2: '1.2 Explosives with a severe projection hazard',
      class3: '1.3 Explosives with a fire',
      class4: '1.4 Minor fire or projection hazard',
      class5: '1.5 An insensitive substance with a mass explosion hazard',
      class6: '1.6 Extremely insensitive articles',
      class7: '2.1 Flammable Gas',
      class8: '2.2 Non-flammable, Non-poisonous Gas',
      class9: '2.3 Oxygen Gas',
      class10: '2.4 Poison Gas',
      class11: '3 Flammable Liquid',
      class12: '4.1 Flammable Solids or Substances',
      class13: '4.2 Flammable solids',
      class14: '4.3 Substances which, in contact with water, emit flammable gases',
      class15: '5.1 Oxidizing substances (agents) by yielding oxygen increase the risk and intensity of fire',
      class16: '5.2 Organic peroxides - most will burn rapidly and are sensitive to impact or friction',
      class17: '6.1 Toxic substances',
      class18: '6.2 Infectious substances',
      class19: '7 Radioactive Substances',
      class20: '8 Corrosives',
      class21: '9 Miscellaneous dangerous substances and articles'
    },
    // Data Scope Type
    dataScopeType: {
      all: 'All Data',
      branch: 'Branch Data',
      department: 'Department Data',
      personal: 'Personal Data'
    },
    // Container Load Type
    containerLoadType: {
      fclExport: 'FCL Export',
      lclExport: 'LCL Export',
      iclExport: 'LCL Export',
      airExport: 'Air Export',
      railExport: 'Rail Export',
      prePort: 'Pre-port',
      lastMile: 'Last Mile',
      rail: 'Rail',
      express: 'Express'
    },
    // Order Source Type
    orderSourceType: {
      QUOTATION: 'Business Quotation',
      SUPPLIER_QUOTATION: 'Supplier Quotation',
      SALES_QUOTATION: 'Sales Quotation',
      PRICE_FCL: 'FCL Rate',
      BOOKING_TASK: 'Booking Task',
      BOOKING: 'Direct Booking',
      API_SYNC_CARGOWARE: 'API Sync (CargoWare)',
      DIRECT_CREATE: 'Direct Create'
    }
  },

  // Order Filter Fields
  order: {
    labels: {
      cargoJobNo: 'Cargo Job No.',
      mblNo: 'MBL No.',
      hblNo: 'HBL No.',
      containerNo: 'Container No.',
      vesselVoyage: 'Vessel/Voyage',
      orderStatus: 'Order Status',
      syncStatus: 'Sync Status',
      etd: 'ETD (Est. Departure)',
      eta: 'ETA (Est. Arrival)',
      airline: 'Airline',
      flightNo: 'Flight No.',
      mawbNo: 'MAWB No.',
      airEtd: 'ETD (Est. Departure)',
      airEta: 'ETA (Est. Arrival)',
      placeOfReceipt: 'Place of Receipt',
      placeOfDelivery: 'Place of Delivery',
      pickupPlace: 'Pickup Location',
      returnPlace: 'Return Location',
      railOrigin: 'Origin Station',
      railDestination: 'Destination Station',
      railCarrier: 'Rail Carrier',
      trainNo: 'Train No.',
      truckPlate: 'Vehicle Plate'
    },
    placeholders: {
      cargoJobNo: 'Please enter Cargo Job No.',
      mblNo: 'Please enter MBL No.',
      hblNo: 'Please enter HBL No.',
      containerNo: 'Please enter Container No.',
      vesselVoyage: 'Please enter vessel/voyage',
      orderStatus: 'Please select order status',
      syncStatus: 'Please select sync status',
      airline: 'Please select airline',
      flightNo: 'Please enter flight no.',
      mawbNo: 'Please enter MAWB no.',
      placeOfReceipt: 'Enter place of receipt',
      placeOfDelivery: 'Enter place of delivery',
      pickupPlace: 'Enter pickup location',
      returnPlace: 'Enter return location',
      railOrigin: 'Enter origin station',
      railDestination: 'Enter destination station',
      trainNo: 'Enter train no.',
      truckPlate: 'Enter vehicle plate'
    }
  },

  // Common Filter Operations
  common: {
    operators: {
      EQ: 'Equal',
      NE: 'Not Equal',
      LIKE: 'Contains',
      NOT_LIKE: 'Not Contains',
      GT: 'Greater Than',
      GTE: 'Greater Than or Equal',
      LT: 'Less Than',
      LTE: 'Less Than or Equal',
      BETWEEN: 'Between',
      IN: 'In',
      NOT_IN: 'Not In',
      IS_NULL: 'Is Empty',
      IS_NOT_NULL: 'Is Not Empty'
    },
    actions: {
      search: 'Search',
      reset: 'Reset',
      expand: 'Expand',
      collapse: 'Collapse',
      addCondition: 'Add/Remove Conditions',
      saveScheme: 'Save as Scheme',
      selectAll: 'Select All',
      clearAll: 'Clear All',
      resetDefault: 'Reset Default'
    },
    messages: {
      noCondition: 'No filter conditions',
      conditionCount: 'Selected {count} fields',
      schemeNameRequired: 'Please enter scheme name',
      schemeSaveSuccess: 'Filter scheme saved successfully',
      schemeDeleteSuccess: 'Filter scheme deleted successfully'
    }
  }
}
